/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ebr_Diff_UnifiedInputs */

const cs_ebr_diff_unified = /** @type {(inputs: Ebr_Diff_UnifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sloučeně`)
};

const en_ebr_diff_unified = /** @type {(inputs: Ebr_Diff_UnifiedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unified`)
};

/**
* | output |
* | --- |
* | "Unified" |
*
* @param {Ebr_Diff_UnifiedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ebr_diff_unified = /** @type {((inputs?: Ebr_Diff_UnifiedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ebr_Diff_UnifiedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ebr_diff_unified(inputs)
	return cs_ebr_diff_unified(inputs)
});